import {Action, handleActions} from "redux-actions";
import {
	APPOINTMENTS_INDIVIDUAL_CONTACTS_FETCHED,
	INDIVIDUAL_CONTACT_ARCHIVE_STATUS_CHANGED,
	INDIVIDUAL_CONTACT_CREATED,
	INDIVIDUAL_CONTACT_EDITED,
	INDIVIDUAL_CONTACT_FETCHED,
	INDIVIDUAL_CONTACTS_FETCHED
} from "../../action/contacts/actionType";
import {ContactsState} from "./ContactsState";

/**
 * Initial state for contact.
 */
const initState: ContactsState = {
	individualContactMap: {},
	allContactsFetched: false
};

const reducer = handleActions({
	[INDIVIDUAL_CONTACT_CREATED]: (state: ContactsState, action: Action<any>): ContactsState => {
		return {
			...state,
			individualContactMap: {
				...state.individualContactMap,
				[action.payload.contact.id]: action.payload.contact
			}
		};
	},
	[INDIVIDUAL_CONTACTS_FETCHED]: (state: ContactsState, action: Action<INDIVIDUAL_CONTACTS_FETCHED>): ContactsState => {
		return {
			...state,
			individualContactMap: action.payload.contacts,
			allContactsFetched: true
		};
	},
	[INDIVIDUAL_CONTACT_EDITED]: (state: ContactsState, action: Action<INDIVIDUAL_CONTACT_EDITED>): ContactsState => {
		return {
			...state,
			individualContactMap: {
				...state.individualContactMap,
				[action.payload.contact.id]: action.payload.contact
			}
		};
	},
	[INDIVIDUAL_CONTACT_FETCHED]: (state: ContactsState, action: Action<INDIVIDUAL_CONTACT_FETCHED>): ContactsState => {
		return {
			...state,
			individualContactMap: {
				...state.individualContactMap,
				[action.payload.contact.id]: action.payload.contact
			}
		};
	},
	[INDIVIDUAL_CONTACT_ARCHIVE_STATUS_CHANGED]: (state: ContactsState,
		action: Action<INDIVIDUAL_CONTACT_ARCHIVE_STATUS_CHANGED>): ContactsState => {
		const contact = state.individualContactMap[action.payload.contactId];
		const contactsMap = {...state.individualContactMap};
		if (contact) {
			const updatedContact = contact.copy({data: contact.data.copy({archived: action.payload.archived})});
			contactsMap[updatedContact.id] = updatedContact;
		}
		return {...state, individualContactMap: contactsMap};
	},
	[APPOINTMENTS_INDIVIDUAL_CONTACTS_FETCHED]: (state: ContactsState,
		action: Action<APPOINTMENTS_INDIVIDUAL_CONTACTS_FETCHED>): ContactsState => {
		return {
			...state,
			individualContactMap: {
				...state.individualContactMap,
				...action.payload.contacts
			}
		};
	}
}, initState);

export default reducer;
